export default "__VITE_ASSET__BGB9I_bm__"